import React, { useState, useEffect } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Modal,
    ModalBody,
    ModalFooter,
    Row,
    ModalHeader,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const SpareList = () => {
    const [modal_list, setmodal_list] = useState(false);
    const [editedMachine, setEditedMachine] = useState(null);

    function tog_list() {
        setmodal_list(!modal_list);
        setEditedMachine(null);
    }

    const [companyData, setCompanyData] = useState([]);
    const fetchCompany = async () => {
        try {
            // Fetch data from your API
            const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/all/sparelist", {
                // headers: {
                //     "Content-Type": "application/json",
                //     Authorization: `Bearer ${authToken}`, // Replace with your actual token
                // },
            });

            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setCompanyData(data);
            } else if (response.status === 401) {
                // Unauthorized: Log out the user
                localStorage.removeItem("authUser");
                localStorage.removeItem("admin");
            } else {
                console.error("Error fetching data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchCompany();
    }, []);

    const [formData, setFormData] = useState({
        refNo: "",
        description: "",
        currentStock: "",
        minStock: "",
        maxStock: "",
        drawing: ''
    });

    useEffect(() => {
        if (editedMachine) {
            setFormData({
                refNo: editedMachine.refNo,
                description: editedMachine.description,
                currentStock: editedMachine.currentStock,
                minStock: editedMachine.minStock,
                maxStock: editedMachine.maxStock,
                drawing: editedMachine.drawing,
            });
        } else {
            setFormData({
                refNo: "",
                description: "",
                currentStock: "",
                minStock: "",
                maxStock: "",
                drawing: ''
            });
        }
    }, [editedMachine]);

    const [responseMessage, setResponseMessage] = useState("");
    const handleInputChange = (e) => {
        if (e.target.type === "file") {
            setFormData({ ...formData, drawing: e.target.files[0] });
        } else {
            // console.log(e.target.name,e.target.value)
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };
   // const authToken = JSON.parse(localStorage.getItem("authUser")).token;

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const apiUrl = editedMachine
                ? `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/update/sparelist/${editedMachine._id}`
                : "http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/create/sparelist";

            const formDataObject = new FormData();
            console.log(formData, 'formDataObject');
            // return false;
            formDataObject.append("refNo", formData.refNo);
            formDataObject.append("description", formData.description);
            formDataObject.append("currentStock", formData.currentStock);
            formDataObject.append("minStock", formData.minStock);
            formDataObject.append("maxStock", formData.maxStock);

            formDataObject.append("drawing", formData.drawing);

            const response = await fetch(apiUrl, {
                method: editedMachine ? "PATCH" : "POST",
                // headers: {


                //     Authorization: `Bearer ${authToken}`,
                // },
                body: formDataObject,
            });

            const responseData = await response.json();

            if (response.ok) {
                toast.success(responseData.message);
                setmodal_list(false);
                setFormData({
                    refNo: "",
                    description: "",
                    currentStock: "",
                    minStock: "",
                    maxStock: "",
                    drawing: ''
                });
                fetchMachine();
            } else {
                toast.error(`Error: ${responseData.error}`);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    const [machineData, setMachineData] = useState([]);

    const fetchMachine = async () => {
        try {
            // Fetch data from your API
            const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/all/sparelist", {
                // headers: {
                //     "Content-Type": "application/json",
                //     Authorization: `Bearer ${authToken}`, // Replace with your actual token
                // },
            });

            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setMachineData(data);
            } else if (response.status === 401) {
                // Unauthorized: Log out the user
                localStorage.removeItem("authUser");
                localStorage.removeItem("admin");
            } else {
                console.error("Error fetching data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchMachine();
    }, []);

    const handleDeleteMachine = async (id) => {
        try {
            // Make API request to delete the user
            const response = await fetch(
                `http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/delete/sparelist/${id}`,
                {
                    method: "DELETE",
                    // headers: {
                    //     Authorization: `Bearer ${authToken}`, // Replace with your actual token
                    // },
                }
            );

            if (response.ok) {
                // If the deletion was successful, refresh the user data
                toast.success("Machine Deleted Successfully");
                fetchMachine();
            } else if (response.status === 401) {
                // Unauthorized: Log out the user
                localStorage.removeItem("authUser");
                localStorage.removeItem("admin");
            } else {
                console.error("Error fetching data:", response.statusText);
            }
        } catch (error) {
            console.error("Error deleting user:", error);
        }
    };

    const [searchTerm, setSearchTerm] = useState("");

    const handleSearchTermChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const filteredMachine = machineData;

    // pagination
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    // Calculate the total number of pages
    const totalPages = Math.ceil(filteredMachine.length / itemsPerPage);

    // Calculate the index of the first and last item of the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // Get the items for the current page
    const currentItems = filteredMachine.slice(indexOfFirstItem, indexOfLastItem);

    // Handle Previous button click
    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Handle Next button click
    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="OptiMize" breadcrumbItem="Machine" />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <h4 className="card-title mb-0">
                                        Add, Edit & Remove Inventory
                                    </h4>
                                </CardHeader>

                                <CardBody>
                                    <div id="customerList">
                                        <Row className="g-4 mb-3">
                                            <Col className="col-sm-auto">
                                                <div className="d-flex gap-1">
                                                    <Button
                                                        color="success"
                                                        className="add-btn"
                                                        onClick={() => tog_list()}
                                                        id="create-btn"
                                                    >
                                                        <i className="ri-add-line align-bottom me-1"></i>{" "}
                                                        Add Inventory Details
                                                    </Button>
                                                </div>
                                            </Col>
                                            <Col className="col-sm">
                                                <div className="d-flex justify-content-sm-end">
                                                    <div className="search-box ms-2">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder="Search..."
                                                            value={searchTerm}
                                                            onChange={handleSearchTermChange}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <div className="table-responsive table-card mt-3 mb-1">
                                            <table
                                                className="table align-middle table-nowrap"
                                                id="customerTable"
                                            >
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Ref No.</th>
                                                        <th className="sort" data-sort="customer_name">
                                                            Description
                                                        </th>
                                                        <th className="sort" data-sort="email">
                                                            Current stocks
                                                        </th>
                                                        <th className="sort" data-sort="email">
                                                            Minimum Stocks
                                                        </th>
                                                        <th className="sort" data-sort="phone">
                                                            Maximum Stocks
                                                        </th>
                                                        <th className="sort" data-sort="action">
                                                            Drawing
                                                        </th>
                                                        <th className="sort" data-sort="action">
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list form-check-all">
                                                    {currentItems === undefined ? (
                                                        <tr>
                                                            <td colSpan="9" className="text-center">
                                                                Loading...
                                                            </td>
                                                        </tr>
                                                    ) : currentItems.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="9" className="text-center">
                                                                No content found
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        currentItems.map((machine, index) => (
                                                            <tr key={index}>

                                                                <td className="customer_name">
                                                                    {machine.refNo}
                                                                </td>
                                                                <td className="email">
                                                                    {machine.description}
                                                                </td>
                                                                <td className="email">{machine.currentStock}</td>
                                                                <td className="phone">
                                                                    {machine.minStock}
                                                                </td>
                                                                <td>{machine.maxStock}</td>
                                                                <td>

                                                                    {machine.drawing && (
                                                                        <div className="logo">
                                                                            <img
                                                                                src={`http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/images/${machine.drawing}`}
                                                                                height="100"
                                                                                width="100"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </td>


                                                                <td>
                                                                    <div className="d-flex gap-2">
                                                                        <div className="edit">
                                                                            <button
                                                                                className="btn btn-warning"
                                                                                onClick={() => {
                                                                                    setmodal_list(true);
                                                                                    setEditedMachine(machine);
                                                                                }}
                                                                            >
                                                                                Edit
                                                                            </button>
                                                                        </div>
                                                                        <div className="remove">
                                                                            <button
                                                                                className="btn btn-danger remove-item-btn"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#deleteRecordModal"
                                                                                onClick={() =>
                                                                                    handleDeleteMachine(machine._id)
                                                                                }
                                                                            >
                                                                                Remove
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className="noresult" style={{ display: "none" }}>
                                                <div className="text-center">
                                                    <lord-icon
                                                        src="https://cdn.lordicon.com/msoeawqm.json"
                                                        trigger="loop"
                                                        colors="primary:#121331,secondary:#08a88a"
                                                        style={{ width: "75px", height: "75px" }}
                                                    ></lord-icon>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                    <p className="text-muted mb-0">
                                                        We've searched more than 150+ Orders We did not find
                                                        any orders for you search.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <div className="pagination-wrap hstack gap-2">
                                                <Link
                                                    className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                                                        }`}
                                                    to="#"
                                                    onClick={handlePrevious}
                                                >
                                                    Previous
                                                </Link>
                                                <ul className="pagination listjs-pagination mb-0">
                                                    <li>
                                                        Page {currentPage} of {totalPages}
                                                    </li>
                                                </ul>
                                                <Link
                                                    className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                                                        }`}
                                                    to="#"
                                                    onClick={handleNext}
                                                >
                                                    Next
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Add Modal */}
            {/* Edit Machine and Add Machine */}
            <Modal
                isOpen={modal_list}
                toggle={() => {
                    setmodal_list(false);
                }}
                centered
            >
                <ModalHeader
                    className="bg-light p-3"
                    id="exampleModalLabel"
                    toggle={() => {
                        tog_list();
                    }}
                >
                    {editedMachine ? "Edit Mchine" : "Add Machine"}
                </ModalHeader>
                {responseMessage && (
                    <div
                        className={`alert ${responseMessage.includes("Error")
                            ? "alert-danger"
                            : "alert-success"
                            } `}
                    >
                        {responseMessage}
                    </div>
                )}
                <form className="tablelist-form">
                    <ModalBody>
                        <div className="mb-3" id="modal-id" style={{ display: "none" }}>
                            <label htmlFor="id-field" className="form-label">
                                ID
                            </label>
                            <input
                                type="text"
                                id="id-field"
                                className="form-control"
                                placeholder="ID"

                                readOnly
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="company_name-field" className="form-label">
                                Part No
                            </label>
                            <input type="text" onChange={handleInputChange} placeholder="ref no" name="refNo" className="form-control" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="company_name-field" className="form-label">
                                Description
                            </label>
                            <input
                                type="text"
                                placeholder="Description"
                                onChange={handleInputChange}
                                name="description" className="form-control" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="company_name-field" className="form-label">
                                Current Stock
                            </label>
                            <input
                                type="text"
                                placeholder="Current Stock"
                                name="currentStock"
                                onChange={handleInputChange}
                                className="form-control" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="company_name-field" className="form-label">
                                Minimum Stock
                            </label>
                            <input
                                type="text"
                                placeholder="Minimum Stock"
                                name="minStock"
                                onChange={handleInputChange}
                                className="form-control" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="company_name-field" className="form-label">
                                Maximum Stock
                            </label>
                            <input
                                type="text"
                                onChange={handleInputChange}
                                placeholder="Maximum Stock"
                                name="maxStock"
                                className="form-control" />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="company_name-field" className="form-label">
                                Drowing
                            </label>
                            <input
                                type="file"
                                name="drawing"
                                onChange={handleInputChange}
                                className="form-control" />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                            <button
                                type="button"
                                className="btn btn-light"
                                onClick={() => setmodal_list(false)}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-success"
                                id="add-btn"
                                onClick={handleSubmit}
                            >
                                {" "}
                                {editedMachine ? "Update Machine" : "Add Machine"}
                            </button>
                        </div>
                    </ModalFooter>
                </form>
            </Modal>
        </React.Fragment>
    );
};

export default SpareList;
